module.exports = __webpack_public_path__ + "static/media/bebedouro_lider_passilo_80s.8c0b8f93.webp";